import { useTranslations } from 'next-intl'

import { Stepper } from '~components/Stepper'
import useGoBack from '~hooks/useGoBack'

import { RegistrationForm } from '../components/RegistrationForm'

export const RegistrationPage = () => {
  const t = useTranslations('register')
  const goBack = useGoBack()

  const handleBackClick = () => {
    goBack('/')
  }

  return (
    <>
      <Stepper
        step={0}
        title={t('title')}
        description={t('description')}
        onBackClick={handleBackClick}
      />
      <RegistrationForm />
    </>
  )
}
